import React, { FC } from 'react';
import GeneralHeadOrMetaTags from './components/genericTags';
import OgMetaTags from './components/ogMetaTags';
import TwitterMetaTags from './components/twitterMetaTags';

import { TSeoTagsProps } from './types/seoTags.types';

const SeoTags: FC<TSeoTagsProps> = ({ model }) => {
  return (
    <>
      <GeneralHeadOrMetaTags model={model} />
      <OgMetaTags model={model} />
      <TwitterMetaTags model={model} />
    </>
  );
};

export default SeoTags;
